<template>
  <div id="show">
    <h1 style="
        font-size: 30px;
        font-weight: bolder;
        color: #22cab3;
        margin-top: 20px;
      ">
      Result of {{ id }}
    </h1>

    <div class="childShow">
      <el-card>
        <div slot="header">
          <span class="tableTitle"></span>
          <el-button class="dowload" icon="el-icon-download" @click="dowload(1, $event)">Dowload</el-button>
        </div>
        <div>
          <el-table :data="expData" stripe height="400">
            <el-table-column prop="geneA" label="GeneA">
            </el-table-column>
            <el-table-column prop="geneB" label="GeneB">
            </el-table-column>
            <el-table-column prop="predictions" label="Prediction"> </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="pageNum" :page-sizes="[10,20,30,50]" :page-size.sync="pageSize"
            layout="total,sizes, prev, pager, next" :total.sync="total">
          </el-pagination>
        </div>
      </el-card>
    </div>

    <div class="childShow">
      <el-card>
        <div slot="header">
          <span class="tableTitle"></span>
          <el-select style="width: 440px; float: right" @change="seqChange" v-model="visSeq">
            <el-option v-for="value in visSeqOp" :key="value.value" :value="value.value" :label="value.label">
            </el-option>
          </el-select>
        </div>
        <div>
          <Chart :chartName="id + '-Gradient'" :chartHotname="id + '-HeatMap'" v-if="visData" :visData="visData"
            :chartHotData="chartHotData"></Chart>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
function convertToElTableFormat(data) {
  const formattedData = [];

  // 获取所有列名
  const columns = Object.keys(data);
  console.log(columns);
  // 假设以第一个列数据的长度为基准，保证所有列数据的长度一致
  const numRows = data[columns[0]].length;

  for (let i = 0; i < numRows; i++) {
    const row = {};
    for (const column of columns) {
      row[column] = data[column][i];
    }
    formattedData.push(row);
  }

  return formattedData;
}

function convertToCustomFormat(array) {
  const result = [];

  for (let i = 0; i < array.length; i++) {
    for (let j = 0; j < array[i].length; j++) {
      result.push([j, i, array[i][j]]);
    }
  }

  return result;
}

function verticalSum(arr) {
  const num=arr.length
  const n = arr[0].length;
  const result = new Array(n).fill(0);

  for (let i = 0; i < num; i++) {
    for (let j = 0; j < n; j++) {
      result[j] += arr[i][j];
    }
  }

  return result;
}

export default {
  name: "Show",
  components: {},
  data() {
    return {
      id: this.$route.params.id,
      expData: [],

      imgurl: {
        chg: "",
        seq: "",
      },
      steps2: 1,

      fileurl: [],
      dowloadTable: "",
      dowloadTable2: "",

      visSeq: 0,
      visSeqOp: [],

      visData: undefined,
      chartHotData: undefined,

      pageNum: 1,
      pageSize: 10,
      total:0,

      isMaize:false
    };
  },

  methods: {
    async getTaskInfo() {
      let data={
        taskID:this.id,
        page:this.pageNum,
        limit:this.pageSize
      }
      let result = await this.$API.reqTaskResultInfo(data);
      // console.log(result1, 'result');
      if (result.code == 200) {
        // console.log(result);
        if(result.project=='maize'){
          this.isMaize=true
        }
        console.log(result['data']);
        let data = result['data']
        this.expData = data.data
        this.total=data.totalLine
        this.pageNum=data.currentPage
        this.pageSize=data.limit
        this.visSeqOp = this.expData.map((x, index) => {
          return {
            value: (this.pageNum-1)*this.pageSize+index,
            label: (this.pageNum-1)*this.pageSize+index + " : " + x.Gene1 +' and '+ x.Gene2,
          };
        });

        this.visSeq=(this.pageNum-1)*this.pageSize
      }
    },
    dowload(flag, event) {
      let dowload_url = "http://124.220.197.196:8085/"+`result/${this.id}_predict.csv`;

      window.open(dowload_url);

      let target = event.target;
      if (target.nodeName === "BUTTON" || target.nodeName === "SPAN") {
        target.parentNode.blur();
      }
      target.blur();
    },

    async seqChange() {
      let result = await this.$API.reqVisImg(this.id, this.visSeq);
      // console.log(result)
      if (result.code == 200) {
        this.$nextTick(() => {
          let name=this.id+"_saliency"
          console.log(result[name])
          this.visData = verticalSum(result[name]);
          this.chartHotData = convertToCustomFormat (result[name]);
        });
      }
    },
    handleSizeChange(){
      this.getTaskInfo();
      this.seqChange();
    },
    handleCurrentChange(){
      this.getTaskInfo();
      this.seqChange();
    }
  },
  created() {
    this.getTaskInfo();
    this.seqChange();
  },
};
</script>

<style>
#show {
  width: 75%;
  margin: 0 auto;

  text-align: center;

  min-width: 1400px;
}

.dowload {
  font-size: 20px;
  float: right;
  height: 50px;
  color: #fff;
  background-color: #d32f2f;
  border-color: #d32f2f;
}
.dowload:hover {
  background: #df6666;
  border-color: #df6666;
  color: #fff;
}
.childShow {
  margin-top: 20px;
  margin-bottom: 20px;
}
.tableTitle {
  margin-left: 20px;
  /* margin: auto; */
  font-size: 30px;
  font-weight: bold;
}
.showimg {
  /* cursor: zoom-in; */
  width: 80%;
  height: 80%;
  /* width: 80%; */
}
</style>
